
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12773',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12773",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.487",
  "data-fetching-client": "static-1.9797",
  "foundations-components": "static-1.8209",
  "foundations-components-legacy": "static-1.1234",
  "foundations-theming": "static-1.4572",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8158",
  "hub-http-shared-msw-handlers": "static-1.10302",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11609",
  "I18n": "static-7.1643",
  "jasmine-runner": "static-1.6594",
  "marketplace-storefront-base": "static-1.12836",
  "quartz": "static-1.7214",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16825",
  "reactive-variable-buffer-atom": "static-1.2994",
  "reporting-testing-lib": "static-1.10042",
  "reselect": "static-3.6",
  "settings-ui-lib": "static-1.12659",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7389",
  "ui-addon-i18n": "static-1.11286",
  "ui-addon-react-router-dom": "static-1.9673",
  "unified-auth": "static-1.658",
  "unified-auth-core-lib": "static-1.940",
  "usage-tracker": "static-1.7490",
  "usage-tracker-core": "static-1.7340",
  "customer-data-property-utils": "static-1.8232",
  "hub-http": "static-1.6359",
  "integrations-lib": "static-1.16584",
  "marketplace-ui-common": "static-1.20220",
  "property-management-iframe": "static-1.13622",
  "quartz-config": "static-1.992",
  "quartz-core": "static-1.6433",
  "quartz-routing": "static-1.644",
  "quick-fetch": "static-1.4022",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4794",
  "ts-schema": "static-1.4186",
  "ui-universal-auth": "static-1.9144",
  "UIComponents": "static-3.8555",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3504",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3491",
  "quartz-webpack": "static-1.3438",
  "bend-plugin-quartz-routing": "static-1.292",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4478",
  "floating-ui": "static-1.58",
  "foundations-assets": "static-1.5011",
  "foundations-theming-specialty": "static-1.2288",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9561",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.41",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5445",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.490",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2224",
  "ui-fonts": "static-1.871",
  "ui-images": "static-2.1192",
  "bend-plugin-foundations-theming": "static-1.3055",
  "foundations-theming-base": "static-1.3557",
  "stylex": "static-1.35",
  "HeadJS": "static-2.775",
  "hs-test-utils-bend-plugin": "static-1.3269",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4462",
  "ai-components-ui-library": "static-1.9294",
  "ai-rendering-library": "static-1.10673",
  "chirp-fetch": "static-1.2025",
  "connections-embed-lib": "static-1.1257",
  "copilot-toolkit": "static-1.11485",
  "feedback-loader": "static-1.29555",
  "laboratory-lib": "static-3.7290",
  "marketplace-embed": "static-1.22507",
  "marketplace-ui-details": "static-1.10115",
  "marketplace-ui-reviews": "static-1.20175",
  "marketplace-ui-tracking": "static-1.14390",
  "sanitize-text": "static-1.8284",
  "ui-addon-video-player": "static-1.8843",
  "usage-tracker-multi": "static-1.5904",
  "usage-tracker-session-replay": "static-1.5176",
  "wootric-nps": "static-1.7086",
  "quartz-head": "static-1.879",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4788",
  "immer": "static-1.33",
  "immerable": "static-1.4288",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2584",
  "reporting-data": "static-1.68109",
  "cssUtils": "static-1.834",
  "flux-actions": "static-1.350",
  "HubStyle": "static-2.11916",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10345",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10500",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7480",
  "icons": "static-2.658",
  "marketplace-ui-apps-core": "static-1.18752",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4647",
  "foundations-components-test-utils": "static-1.5692",
  "quartz-i18n": "static-1.889",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.75",
  "ads-unified-auth-lib": "static-1.512",
  "google-sheets-integration-lib": "static-1.637",
  "microsoft-drive-integration-lib": "static-1.800",
  "surveymonkey-integration-lib": "static-1.94",
  "slack-ui-library": "static-1.10536",
  "fsm": "static-1.3868",
  "customer-data-objects": "static-1.7816",
  "property-translator": "static-1.5534",
  "hs-locale-management": "static-1.186",
  "frontend-preferences-client": "static-1.8064",
  "hs-promise-utils": "static-1.5731",
  "hubspot-apollo-client": "static-1.5015",
  "integrations-error-boundary-lib": "static-1.13999",
  "integrations-tracking-lib": "static-1.5745",
  "native-integrations-shared-strings": "static-1.7918",
  "sanitize": "static-1.4614",
  "superstore": "static-1.4897",
  "ui-shepherd-react": "static-3.10395",
  "ai-settings-ui-library": "static-1.8109",
  "hub-http-janus": "static-1.850",
  "hubspotter-http": "static-1.4755",
  "immutable-less": "static-1.4789",
  "marketplace-ui-client-types": "static-1.17627",
  "nav-meta": "static-1.29971",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18180",
  "inbound-db-properties-service-client": "static-1.3951",
  "property-management-common": "static-1.5910",
  "ui-addon-iframeable": "static-1.9206",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.549",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.889",
  "quartz-test": "static-1.889",
  "quartz-tracking": "static-1.593",
  "trellis-components": "static-1.2243",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.204",
  "bender-build-tools": "static-1.3301",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21974",
  "ContentUtils": "static-1.68763",
  "customer-data-objects-ui-components": "static-1.13167",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2636",
  "breeze-engine-core": "static-1.468",
  "breeze-onboarding-components": "static-1.307",
  "customer-data-filters-ui": "static-1.40282",
  "customer-data-reference-ui-components": "static-1.13313",
  "embedded-academy-lib": "static-1.14798",
  "ExportDialog": "static-6.10517",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41648",
  "reporting-snowflake": "static-1.56727",
  "reporting-ui-components": "static-2.65380",
  "reporting-visualizations": "static-1.60185",
  "trellis-theming": "static-1.1081",
  "ui-addon-teams": "static-1.21728",
  "integrations-reconnect-lib": "static-1.230",
  "magpie-lib": "static-1.5644",
  "navigation-components": "static-1.18334",
  "breeze-engine-lib": "static-1.1190",
  "magpie-types": "static-1.5104",
  "simple-logging-lib": "static-1.3186",
  "ai-studio-lib": "static-1.12014",
  "app-governance-lib": "static-1.1980",
  "developer-experience-shared-components": "static-1.10664",
  "hubspot-prosemirror": "static-1.18623",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8148",
  "ui-product-approvals": "static-1.28685",
  "ui-tool-access": "static-1.10289",
  "usage-based-billing-components-lib": "static-1.9513",
  "usage-tracker-anonymous": "static-1.5907",
  "usage-tracker-public": "static-1.7301",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3692",
  "persist-promise": "static-1.3839",
  "reference-resolvers": "static-1.8313",
  "ui-extensibility-client-types": "static-1.4062",
  "hubspot-apollo-cache": "static-1.474",
  "universal-page-editor-lib": "static-1.3149",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3160",
  "atom": "static-1.5213",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6123",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1682",
  "crm-component-utils": "static-1.39438",
  "crm-properties-common-lib": "static-1.6028",
  "customer-data-properties": "static-1.52024",
  "framework-data-schema-resolvers": "static-1.7031",
  "property-value-citations": "static-1.2638",
  "reference-resolvers-lite": "static-1.8234",
  "ui-business-units-lib": "static-1.9207",
  "navigation-messaging": "static-1.7661",
  "hubspotter-http-shared-msw-handlers": "static-1.10300",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4952",
  "content-icons-ui": "static-1.2269",
  "customer-data-ui-utilities": "static-1.9962",
  "conversations-skeleton-state": "static-1.7385",
  "crm-message-bus": "static-1.43348",
  "customer-data-filters-ui-msw-helpers": "static-1.22717",
  "events-data-lib": "static-1.373",
  "FormUrlGenerator": "static-2.4859",
  "framework-builder-read-service-client": "static-1.4110",
  "framework-data-schema-quick-fetch": "static-1.6936",
  "multi-account-reference-resolvers": "static-1.1119",
  "onboarding-tours": "static-1.16867",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14070",
  "academy-common-lib": "static-1.14258",
  "content-assistance-lib": "static-1.7975",
  "dashboard-lib": "static-1.82057",
  "file-manager-components": "static-1.24028",
  "getting-started-shared-tasks": "static-1.18792",
  "hubspot-prosemirror-plugins": "static-1.18615",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20072",
  "share-with-third-party-component-lib": "static-1.8842",
  "ui-addon-draggable": "static-3.4898",
  "ui-asset-management-lib": "static-1.11214",
  "user-context": "static-1.5246",
  "growth-payments-core": "static-1.25778",
  "reporting-plugins": "static-1.10538",
  "reporting-reports": "static-1.67787",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.863",
  "nest": "static-1.371",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10765",
  "framework-listing-lib": "static-2.29074",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31017",
  "apps-service-types": "static-1.3938",
  "oauth-service-types": "static-1.4392",
  "content-media-capture": "static-1.4939",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23864",
  "ui-addon-emoji-picker": "static-1.10022",
  "video-components-external": "static-1.11737",
  "video-data-lib": "static-1.35395",
  "react-dnd-compat": "static-1.4752",
  "ui-product-approvals-common": "static-1.580",
  "onboarding-scopes": "static-1.6598",
  "onboarding-tours-client": "static-1.5081",
  "platform-infra-nav-components": "static-1.7778",
  "subscription-experience-data-types": "static-1.15090",
  "crm-record-cards-service-types": "static-1.3690",
  "location-customization-utils-lib": "static-1.9648",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6126",
  "signup-constants": "static-1.19204",
  "signup-ui-url-generator": "static-2.8196",
  "card-properties-lib": "static-1.44603",
  "commerce-subscription-lib": "static-1.37469",
  "crm-actions": "static-1.6478",
  "crm-cards-sdk": "static-1.43999",
  "customer-data-properties-shared-msw-handlers": "static-1.9629",
  "customer-data-tracking": "static-1.7024",
  "hs-resources": "static-1.316",
  "pulse": "static-1.742",
  "calling-global-api": "static-1.64958",
  "calling-internal-common": "static-1.31450",
  "calling-lifecycle-internal": "static-1.66340",
  "calling-lifecycle-messages": "static-1.58634",
  "commerce-products-lib": "static-1.10072",
  "conditional-properties-service-client": "static-1.3902",
  "crm-links": "static-1.6446",
  "crm-pipelines-api-client-types": "static-1.4242",
  "external-options-client-types": "static-1.4231",
  "formula-editor": "static-1.14509",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4322",
  "meetings-icalendar-utils-lib": "static-1.771",
  "multi-currency-client-types": "static-1.3796",
  "object-builder-ui-client": "static-1.49217",
  "pipeline-validation-client-types": "static-1.4071",
  "smart-property-lib": "static-1.7965",
  "tiered-pricing": "static-1.1586",
  "topics-actions-lib": "static-1.230",
  "ui-addon-form-validation": "static-1.11129",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.150",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1237",
  "growth-data-modal": "static-1.5659",
  "growth-onboarding-confetti": "static-1.3203",
  "growth-onboarding-next-action-utils": "static-1.2308",
  "onboarding-tours-utils": "static-1.933",
  "ui-shepherd-tracker": "static-1.7776",
  "academy-service-client": "static-1.3821",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39527",
  "FileManagerLib": "static-1.39668",
  "SafeStorage": "static-1.4538",
  "video-embed": "static-1.36229",
  "ui-coaching-tips": "static-1.28938",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24672",
  "viral-links-lib": "static-1.7208",
  "data-token-picker": "static-1.16652",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.377",
  "timezone-utils": "static-2.5381",
  "seat-types-lib": "static-1.311",
  "getting-started-shared-tasks-store": "static-1.17910",
  "ui-addon-opt": "static-4.8499",
  "campaign-roi-lib": "static-1.9521",
  "ui-addon-calendars": "static-2.5460",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25728",
  "framework-data-table": "static-2.12225",
  "marketing-platform-lib": "static-1.7004",
  "nudge-client-utils": "static-1.2878",
  "nudge-custom-ui-functions": "static-1.1273",
  "switchboard-lib": "static-1.363",
  "app-users-service-client": "static-1.5750",
  "app-users-service-types": "static-1.5158",
  "mini-checkout-client": "static-1.27141",
  "onboarding-utils": "static-1.5495",
  "permissions-shared-i18n-strings-fe": "static-1.2062",
  "ui-coaching-tips-shared-config": "static-1.28923",
  "content-media-composition-data-lib": "static-1.12743",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4563",
  "commerce-tours-lib": "static-1.6358",
  "growth-onboarding-reliability": "static-1.5219",
  "sales-checkout-service-client": "static-1.3723",
  "content-media-compositions": "static-2.16750",
  "media-bridge-lib": "static-1.19168",
  "edison-service-client-types": "static-1.526",
  "crm_data": "static-4.92394",
  "customer-data-sidebar": "static-2.46388",
  "enrichment-properties-lib": "static-1.17083",
  "ui-addon-draggable-compat": "static-2.4398",
  "universal-record-utils-lib": "static-1.1314",
  "commerce-billing-lib": "static-1.19538",
  "commerce-shared-components-lib": "static-1.18883",
  "commerce-tools-ui-lib": "static-1.10736",
  "crm-fe-perf": "static-1.23039",
  "event-emitter": "static-1.1087",
  "bend-plugin-pulse": "static-1.245",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31457",
  "shared-worker-versioning": "static-1.11173",
  "calling-usage-tracker": "static-1.6680",
  "voice-sms-access-library": "static-1.1498",
  "commerce-permissions": "static-1.912",
  "products-iframe-lib": "static-1.8307",
  "products-ui-components-shared-msw-handlers": "static-1.10684",
  "bark-lib": "static-1.16600",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.426",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10385",
  "policy-lib": "static-1.6923",
  "react-tinymce": "static-1.55605",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10448",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54731",
  "tinymce-plugins": "static-1.57845",
  "tinymce-themes": "static-1.56701",
  "onboarding-data-sync-lib": "static-1.2208",
  "growth-onboarding-next-action-components": "static-1.2336",
  "user-context-client": "static-1.4716",
  "audio-components": "static-1.6131",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37179",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4672",
  "video-components": "static-1.13739",
  "outpost": "static-1.4307",
  "growth-onboarding-feedback-components": "static-1.6716",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21919",
  "sales-email-signature-service-client": "static-1.3987",
  "ts-utils-lib": "static-1.311",
  "crm-export-dialog": "static-1.6422",
  "crm-index-associations-lib": "static-1.6579",
  "crm-view-components": "static-1.688",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7470",
  "nudge-custom-function-registry": "static-1.2635",
  "nudge-renderer-utils": "static-1.2954",
  "whisper-core-api": "static-1.6923",
  "InboxConnectUtils": "static-4.15182",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5852",
  "settings-content-modals": "static-1.46468",
  "js-cookie": "static-1.18",
  "crm_universal": "static-1.22253",
  "customer-data-email": "static-1.18280",
  "card-payment-highlight-lib": "static-1.37560",
  "card-subscription-highlight-lib": "static-1.39892",
  "commerce-contract-lib": "static-1.12710",
  "invoices-highlight-card-lib": "static-1.55168",
  "orders-highlight-card-lib": "static-1.21841",
  "products-highlight-card-lib": "static-1.18355",
  "quotes-highlight-card-lib": "static-1.72470",
  "crm-source-interpretation-lib": "static-1.5469",
  "crm-object-search-query-utilities": "static-1.9885",
  "utility-belt": "static-1.2669",
  "payments-enrollment-embed-lib": "static-1.23331",
  "stripe-embedded-components": "static-1.7754",
  "customer-data-rte": "static-1.33347",
  "cv-backend-services": "static-1.1573",
  "growth-onboarding-empty-states": "static-1.6001",
  "payments-post-enroll-local-storage-lib": "static-1.5244",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38560",
  "trials-service-types": "static-1.4021",
  "calling-orchestration-schema": "static-1.36275",
  "sales-views-client-types": "static-1.4395",
  "react-reducer-toolkit": "static-1.15969",
  "hub-http-contrib": "static-1.3181",
  "interframe": "static-3.4896",
  "tinymce-data": "static-1.40816",
  "ui-addon-sales-email": "static-1.5348",
  "layout-dnd-components": "static-1.12717",
  "layout-dnd-utils": "static-1.11692",
  "ui-brand-identity-lib": "static-1.15783",
  "NamespacedHubStyle": "static-2.9158",
  "meetings-connect-utils-lib": "static-1.7743",
  "social-insights-client-types": "static-1.22410",
  "crm-index-visualization-core": "static-1.4313",
  "checkout-sdk": "static-3.23984",
  "company-details-components": "static-1.6335",
  "payment-method-components": "static-1.7003",
  "pricing-pages-ui-components": "static-1.14810",
  "quote-checkout-service-types": "static-1.3602",
  "upgrade-catalog-service-types": "static-1.3657",
  "access-control-lib": "static-1.10575",
  "EmailComponents": "static-1.55154",
  "EmailData": "static-1.53831",
  "redux-less": "static-2.9620",
  "sequences-lib": "static-1.8275",
  "ui-gdpr-components": "static-1.10490",
  "products-ui-components": "static-1.40590",
  "accounting-integrations-ui-components": "static-1.7290",
  "invoices-ui-lib": "static-1.55184",
  "commerce-products-api": "static-1.2493",
  "invoices-iframe-lib": "static-1.57242",
  "quotes-modal-lib": "static-1.103148",
  "quotes-ui-lib": "static-1.81191",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28612",
  "ContentData": "static-1.68838",
  "layout-data-lib": "static-1.10017",
  "checkout-service-types": "static-1.3901",
  "hub-http-rxjs": "static-1.816",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4074",
  "billing-payments-client-types": "static-1.4127",
  "react-performance-metrics-lib": "static-1.695",
  "pricing-pages-api": "static-1.14675",
  "ContentComponents": "static-2.71719",
  "marketing-contacts-lib": "static-1.10500",
  "marketing-email-service-types": "static-1.2007",
  "messaging-editing-lib": "static-1.46678",
  "messaging-usage-based-billing-components-lib": "static-1.1540",
  "automation-ui-source-apps": "static-1.19276",
  "automation-ui-types": "static-1.20194",
  "messaging-types-lib": "static-1.46415",
  "onboarding-settings-client": "static-1.4643",
  "sequences-client-types-lib": "static-1.8132",
  "commerce-tax-lib": "static-1.674",
  "price-books-api": "static-1.1301",
  "price-books-components": "static-1.1359",
  "property-description-translator": "static-1.3978",
  "ramp-editor": "static-1.520",
  "commerce-analytics-service-client": "static-1.3711",
  "totals-ui-components": "static-1.23965",
  "SalesContentIndexUI": "static-3.9438",
  "advanced-menus-core": "static-1.15361",
  "advanced-menus-lib": "static-1.12269",
  "ui-memberships-settings-lib": "static-1.34414",
  "segments-query-core": "static-1.1558",
  "automation-ui-ubb": "static-1.6110",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7476",
  "data-token-views": "static-1.16633",
  "forms-utils-lib": "static-1.12844",
  "payments-embed-points-lib": "static-1.13319",
  "simple-menus-core": "static-1.15360",
  "simple-menus-lib": "static-1.16877",
  "videoconference-integration-components": "static-1.7032",
  "mc-hard-limits-client-types": "static-1.36",
  "marketing-contacts-client": "static-1.7647",
  "automation-applications-service-types": "static-1.3596",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77480",
  "short-messages-app-service-client": "static-1.4060",
  "web-interactives-components": "static-1.14002",
  "web-interactives-data": "static-1.14003",
  "messaging-shared-utils-lib": "static-1.989",
  "messaging-user-info-utils-lib": "static-1.1159",
  "email-portal-health-service-types": "static-1.1115",
  "line-items-api": "static-1.892",
  "commerce-totals-service-types": "static-1.3922",
  "FireAlarmUi": "static-1.4613",
  "sales-templates-service-types-lib": "static-1.4274",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22130",
  "automation-ui-usage-tracking": "static-1.21593",
  "data-studio-ubb": "static-1.3114",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27333",
  "collaboration-sidebar": "static-1.58254",
  "content-management-data-lib": "static-1.5658",
  "copilot-plugins": "static-1.11458",
  "cta-picker": "static-1.36754",
  "customer-agent-discovery-components-lib": "static-1.3473",
  "editor-components": "static-1.13433",
  "editor-iframe-lib": "static-1.8598",
  "error-messaging-js": "static-1.5332",
  "FormsCommonComponents": "static-1.86185",
  "pictos": "static-7.187",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10785",
  "SharedLegalStrings": "static-1.1882",
  "smart-content-core": "static-1.42813",
  "smart-content-lib": "static-1.43466",
  "social-composer-lib": "static-1.59646",
  "structured-content-lib": "static-1.25555",
  "theme-previewer-lib": "static-1.53616",
  "tinymce-copilot": "static-1.16799",
  "xray-recommendation-lib": "static-1.8083",
  "automation-ui-routing": "static-1.21551",
  "sql-reporting-client-types": "static-1.5753",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42490",
  "campaigns-utils-lib": "static-1.3332",
  "reporting-enablement": "static-1.23377",
  "chatspot-widget-iframe": "static-1.21965",
  "collaboration-sidebar-common": "static-1.3051",
  "forms-ai-lib": "static-1.4538",
  "codemirror-dlb": "static-1.59039",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6573",
  "report-customization-components": "static-1.13537",
  "data-quality-ui-library": "static-1.13397",
  "reporting-filters": "static-1.661",
  "reporting-insights-lib": "static-1.2143"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12773",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.487",
  "data-fetching-client": "/data-fetching-client/static-1.9797",
  "foundations-components": "/foundations-components/static-1.8209",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1234",
  "foundations-theming": "/foundations-theming/static-1.4572",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8158",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10302",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11609",
  "I18n": "/I18n/static-7.1643",
  "jasmine-runner": "/jasmine-runner/static-1.6594",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12836",
  "quartz": "/quartz/static-1.7214",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16825",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2994",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10042",
  "reselect": "/reselect/static-3.6",
  "settings-ui-lib": "/settings-ui-lib/static-1.12659",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7389",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11286",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9673",
  "unified-auth": "/unified-auth/static-1.658",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.940",
  "usage-tracker": "/usage-tracker/static-1.7490",
  "usage-tracker-core": "/usage-tracker-core/static-1.7340",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8232",
  "hub-http": "/hub-http/static-1.6359",
  "integrations-lib": "/integrations-lib/static-1.16584",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20220",
  "property-management-iframe": "/property-management-iframe/static-1.13622",
  "quartz-config": "/quartz-config/static-1.992",
  "quartz-core": "/quartz-core/static-1.6433",
  "quartz-routing": "/quartz-routing/static-1.644",
  "quick-fetch": "/quick-fetch/static-1.4022",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4794",
  "ts-schema": "/ts-schema/static-1.4186",
  "ui-universal-auth": "/ui-universal-auth/static-1.9144",
  "UIComponents": "/UIComponents/static-3.8555",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3504",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3491",
  "quartz-webpack": "/quartz-webpack/static-1.3438",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.292",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4478",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.5011",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2288",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9561",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5445",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2224",
  "ui-fonts": "/ui-fonts/static-1.871",
  "ui-images": "/ui-images/static-2.1192",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3055",
  "foundations-theming-base": "/foundations-theming-base/static-1.3557",
  "stylex": "/stylex/static-1.35",
  "HeadJS": "/HeadJS/static-2.775",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3269",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4462",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9294",
  "ai-rendering-library": "/ai-rendering-library/static-1.10673",
  "chirp-fetch": "/chirp-fetch/static-1.2025",
  "connections-embed-lib": "/connections-embed-lib/static-1.1257",
  "copilot-toolkit": "/copilot-toolkit/static-1.11485",
  "feedback-loader": "/feedback-loader/static-1.29555",
  "laboratory-lib": "/laboratory-lib/static-3.7290",
  "marketplace-embed": "/marketplace-embed/static-1.22507",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10115",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20175",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14390",
  "sanitize-text": "/sanitize-text/static-1.8284",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8843",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5904",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5176",
  "wootric-nps": "/wootric-nps/static-1.7086",
  "quartz-head": "/quartz-head/static-1.879",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4788",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4288",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2584",
  "reporting-data": "/reporting-data/static-1.68109",
  "cssUtils": "/cssUtils/static-1.834",
  "flux-actions": "/flux-actions/static-1.350",
  "HubStyle": "/HubStyle/static-2.11916",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10345",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10500",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7480",
  "icons": "/icons/static-2.658",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18752",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4647",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5692",
  "quartz-i18n": "/quartz-i18n/static-1.889",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.75",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.512",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.637",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.800",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.94",
  "slack-ui-library": "/slack-ui-library/static-1.10536",
  "fsm": "/fsm/static-1.3868",
  "customer-data-objects": "/customer-data-objects/static-1.7816",
  "property-translator": "/property-translator/static-1.5534",
  "hs-locale-management": "/hs-locale-management/static-1.186",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8064",
  "hs-promise-utils": "/hs-promise-utils/static-1.5731",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5015",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13999",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5745",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7918",
  "sanitize": "/sanitize/static-1.4614",
  "superstore": "/superstore/static-1.4897",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10395",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8109",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "hubspotter-http": "/hubspotter-http/static-1.4755",
  "immutable-less": "/immutable-less/static-1.4789",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17627",
  "nav-meta": "/nav-meta/static-1.29971",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18180",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3951",
  "property-management-common": "/property-management-common/static-1.5910",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9206",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.889",
  "quartz-test": "/quartz-test/static-1.889",
  "quartz-tracking": "/quartz-tracking/static-1.593",
  "trellis-components": "/trellis-components/static-1.2243",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.204",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21974",
  "ContentUtils": "/ContentUtils/static-1.68763",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13167",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2636",
  "breeze-engine-core": "/breeze-engine-core/static-1.468",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.307",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40282",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13313",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14798",
  "ExportDialog": "/ExportDialog/static-6.10517",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41648",
  "reporting-snowflake": "/reporting-snowflake/static-1.56727",
  "reporting-ui-components": "/reporting-ui-components/static-2.65380",
  "reporting-visualizations": "/reporting-visualizations/static-1.60185",
  "trellis-theming": "/trellis-theming/static-1.1081",
  "ui-addon-teams": "/ui-addon-teams/static-1.21728",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.230",
  "magpie-lib": "/magpie-lib/static-1.5644",
  "navigation-components": "/navigation-components/static-1.18334",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1190",
  "magpie-types": "/magpie-types/static-1.5104",
  "simple-logging-lib": "/simple-logging-lib/static-1.3186",
  "ai-studio-lib": "/ai-studio-lib/static-1.12014",
  "app-governance-lib": "/app-governance-lib/static-1.1980",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10664",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18623",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8148",
  "ui-product-approvals": "/ui-product-approvals/static-1.28685",
  "ui-tool-access": "/ui-tool-access/static-1.10289",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9513",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5907",
  "usage-tracker-public": "/usage-tracker-public/static-1.7301",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3692",
  "persist-promise": "/persist-promise/static-1.3839",
  "reference-resolvers": "/reference-resolvers/static-1.8313",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4062",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.474",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3149",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3160",
  "atom": "/atom/static-1.5213",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6123",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1682",
  "crm-component-utils": "/crm-component-utils/static-1.39438",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6028",
  "customer-data-properties": "/customer-data-properties/static-1.52024",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7031",
  "property-value-citations": "/property-value-citations/static-1.2638",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8234",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9207",
  "navigation-messaging": "/navigation-messaging/static-1.7661",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10300",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4952",
  "content-icons-ui": "/content-icons-ui/static-1.2269",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9962",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7385",
  "crm-message-bus": "/crm-message-bus/static-1.43348",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22717",
  "events-data-lib": "/events-data-lib/static-1.373",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4859",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4110",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6936",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1119",
  "onboarding-tours": "/onboarding-tours/static-1.16867",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14070",
  "academy-common-lib": "/academy-common-lib/static-1.14258",
  "content-assistance-lib": "/content-assistance-lib/static-1.7975",
  "dashboard-lib": "/dashboard-lib/static-1.82057",
  "file-manager-components": "/file-manager-components/static-1.24028",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18792",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18615",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20072",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8842",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4898",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11214",
  "user-context": "/user-context/static-1.5246",
  "growth-payments-core": "/growth-payments-core/static-1.25778",
  "reporting-plugins": "/reporting-plugins/static-1.10538",
  "reporting-reports": "/reporting-reports/static-1.67787",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.863",
  "nest": "/nest/static-1.371",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10765",
  "framework-listing-lib": "/framework-listing-lib/static-2.29074",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31017",
  "apps-service-types": "/apps-service-types/static-1.3938",
  "oauth-service-types": "/oauth-service-types/static-1.4392",
  "content-media-capture": "/content-media-capture/static-1.4939",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23864",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10022",
  "video-components-external": "/video-components-external/static-1.11737",
  "video-data-lib": "/video-data-lib/static-1.35395",
  "react-dnd-compat": "/react-dnd-compat/static-1.4752",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.580",
  "onboarding-scopes": "/onboarding-scopes/static-1.6598",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5081",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7778",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15090",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3690",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9648",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6126",
  "signup-constants": "/signup-constants/static-1.19204",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8196",
  "card-properties-lib": "/card-properties-lib/static-1.44603",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37469",
  "crm-actions": "/crm-actions/static-1.6478",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43999",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9629",
  "customer-data-tracking": "/customer-data-tracking/static-1.7024",
  "hs-resources": "/hs-resources/static-1.316",
  "pulse": "/pulse/static-1.742",
  "calling-global-api": "/calling-global-api/static-1.64958",
  "calling-internal-common": "/calling-internal-common/static-1.31450",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66340",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58634",
  "commerce-products-lib": "/commerce-products-lib/static-1.10072",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3902",
  "crm-links": "/crm-links/static-1.6446",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4242",
  "external-options-client-types": "/external-options-client-types/static-1.4231",
  "formula-editor": "/formula-editor/static-1.14509",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4322",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.771",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3796",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49217",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4071",
  "smart-property-lib": "/smart-property-lib/static-1.7965",
  "tiered-pricing": "/tiered-pricing/static-1.1586",
  "topics-actions-lib": "/topics-actions-lib/static-1.230",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11129",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.150",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1237",
  "growth-data-modal": "/growth-data-modal/static-1.5659",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3203",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2308",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.933",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7776",
  "academy-service-client": "/academy-service-client/static-1.3821",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39527",
  "FileManagerLib": "/FileManagerLib/static-1.39668",
  "SafeStorage": "/SafeStorage/static-1.4538",
  "video-embed": "/video-embed/static-1.36229",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28938",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24672",
  "viral-links-lib": "/viral-links-lib/static-1.7208",
  "data-token-picker": "/data-token-picker/static-1.16652",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.377",
  "timezone-utils": "/timezone-utils/static-2.5381",
  "seat-types-lib": "/seat-types-lib/static-1.311",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17910",
  "ui-addon-opt": "/ui-addon-opt/static-4.8499",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9521",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5460",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25728",
  "framework-data-table": "/framework-data-table/static-2.12225",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7004",
  "nudge-client-utils": "/nudge-client-utils/static-1.2878",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1273",
  "switchboard-lib": "/switchboard-lib/static-1.363",
  "app-users-service-client": "/app-users-service-client/static-1.5750",
  "app-users-service-types": "/app-users-service-types/static-1.5158",
  "mini-checkout-client": "/mini-checkout-client/static-1.27141",
  "onboarding-utils": "/onboarding-utils/static-1.5495",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2062",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28923",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12743",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4563",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6358",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5219",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3723",
  "content-media-compositions": "/content-media-compositions/static-2.16750",
  "media-bridge-lib": "/media-bridge-lib/static-1.19168",
  "edison-service-client-types": "/edison-service-client-types/static-1.526",
  "crm_data": "/crm_data/static-4.92394",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46388",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17083",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4398",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1314",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19538",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18883",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10736",
  "crm-fe-perf": "/crm-fe-perf/static-1.23039",
  "event-emitter": "/event-emitter/static-1.1087",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.245",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31457",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11173",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6680",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1498",
  "commerce-permissions": "/commerce-permissions/static-1.912",
  "products-iframe-lib": "/products-iframe-lib/static-1.8307",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10684",
  "bark-lib": "/bark-lib/static-1.16600",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.426",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10385",
  "policy-lib": "/policy-lib/static-1.6923",
  "react-tinymce": "/react-tinymce/static-1.55605",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10448",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54731",
  "tinymce-plugins": "/tinymce-plugins/static-1.57845",
  "tinymce-themes": "/tinymce-themes/static-1.56701",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2208",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2336",
  "user-context-client": "/user-context-client/static-1.4716",
  "audio-components": "/audio-components/static-1.6131",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37179",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4672",
  "video-components": "/video-components/static-1.13739",
  "outpost": "/outpost/static-1.4307",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6716",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21919",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3987",
  "ts-utils-lib": "/ts-utils-lib/static-1.311",
  "crm-export-dialog": "/crm-export-dialog/static-1.6422",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6579",
  "crm-view-components": "/crm-view-components/static-1.688",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7470",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2635",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2954",
  "whisper-core-api": "/whisper-core-api/static-1.6923",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15182",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5852",
  "settings-content-modals": "/settings-content-modals/static-1.46468",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_universal": "/crm_universal/static-1.22253",
  "customer-data-email": "/customer-data-email/static-1.18280",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37560",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39892",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12710",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55168",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21841",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18355",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72470",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5469",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9885",
  "utility-belt": "/utility-belt/static-1.2669",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23331",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7754",
  "customer-data-rte": "/customer-data-rte/static-1.33347",
  "cv-backend-services": "/cv-backend-services/static-1.1573",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6001",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5244",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38560",
  "trials-service-types": "/trials-service-types/static-1.4021",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36275",
  "sales-views-client-types": "/sales-views-client-types/static-1.4395",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.15969",
  "hub-http-contrib": "/hub-http-contrib/static-1.3181",
  "interframe": "/interframe/static-3.4896",
  "tinymce-data": "/tinymce-data/static-1.40816",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5348",
  "layout-dnd-components": "/layout-dnd-components/static-1.12717",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11692",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15783",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9158",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7743",
  "social-insights-client-types": "/social-insights-client-types/static-1.22410",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4313",
  "checkout-sdk": "/checkout-sdk/static-3.23984",
  "company-details-components": "/company-details-components/static-1.6335",
  "payment-method-components": "/payment-method-components/static-1.7003",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14810",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3602",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3657",
  "access-control-lib": "/access-control-lib/static-1.10575",
  "EmailComponents": "/EmailComponents/static-1.55154",
  "EmailData": "/EmailData/static-1.53831",
  "redux-less": "/redux-less/static-2.9620",
  "sequences-lib": "/sequences-lib/static-1.8275",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10490",
  "products-ui-components": "/products-ui-components/static-1.40590",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7290",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55184",
  "commerce-products-api": "/commerce-products-api/static-1.2493",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57242",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103148",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81191",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28612",
  "ContentData": "/ContentData/static-1.68838",
  "layout-data-lib": "/layout-data-lib/static-1.10017",
  "checkout-service-types": "/checkout-service-types/static-1.3901",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.816",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4074",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4127",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.695",
  "pricing-pages-api": "/pricing-pages-api/static-1.14675",
  "ContentComponents": "/ContentComponents/static-2.71719",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10500",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2007",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46678",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1540",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19276",
  "automation-ui-types": "/automation-ui-types/static-1.20194",
  "messaging-types-lib": "/messaging-types-lib/static-1.46415",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4643",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8132",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.674",
  "price-books-api": "/price-books-api/static-1.1301",
  "price-books-components": "/price-books-components/static-1.1359",
  "property-description-translator": "/property-description-translator/static-1.3978",
  "ramp-editor": "/ramp-editor/static-1.520",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3711",
  "totals-ui-components": "/totals-ui-components/static-1.23965",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9438",
  "advanced-menus-core": "/advanced-menus-core/static-1.15361",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12269",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34414",
  "segments-query-core": "/segments-query-core/static-1.1558",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6110",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7476",
  "data-token-views": "/data-token-views/static-1.16633",
  "forms-utils-lib": "/forms-utils-lib/static-1.12844",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13319",
  "simple-menus-core": "/simple-menus-core/static-1.15360",
  "simple-menus-lib": "/simple-menus-lib/static-1.16877",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7032",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.36",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7647",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3596",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77480",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4060",
  "web-interactives-components": "/web-interactives-components/static-1.14002",
  "web-interactives-data": "/web-interactives-data/static-1.14003",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.989",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1159",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1115",
  "line-items-api": "/line-items-api/static-1.892",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3922",
  "FireAlarmUi": "/FireAlarmUi/static-1.4613",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4274",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22130",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21593",
  "data-studio-ubb": "/data-studio-ubb/static-1.3114",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27333",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58254",
  "content-management-data-lib": "/content-management-data-lib/static-1.5658",
  "copilot-plugins": "/copilot-plugins/static-1.11458",
  "cta-picker": "/cta-picker/static-1.36754",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3473",
  "editor-components": "/editor-components/static-1.13433",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8598",
  "error-messaging-js": "/error-messaging-js/static-1.5332",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86185",
  "pictos": "/pictos/static-7.187",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10785",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1882",
  "smart-content-core": "/smart-content-core/static-1.42813",
  "smart-content-lib": "/smart-content-lib/static-1.43466",
  "social-composer-lib": "/social-composer-lib/static-1.59646",
  "structured-content-lib": "/structured-content-lib/static-1.25555",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53616",
  "tinymce-copilot": "/tinymce-copilot/static-1.16799",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8083",
  "automation-ui-routing": "/automation-ui-routing/static-1.21551",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5753",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42490",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3332",
  "reporting-enablement": "/reporting-enablement/static-1.23377",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21965",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3051",
  "forms-ai-lib": "/forms-ai-lib/static-1.4538",
  "codemirror-dlb": "/codemirror-dlb/static-1.59039",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6573",
  "report-customization-components": "/report-customization-components/static-1.13537",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13397",
  "reporting-filters": "/reporting-filters/static-1.661",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2143"
}
};
